import { render, staticRenderFns } from "./ServicePolicyPage.vue?vue&type=template&id=78534c8e"
import script from "./ServicePolicyPage.vue?vue&type=script&lang=js"
export * from "./ServicePolicyPage.vue?vue&type=script&lang=js"
import style0 from "./ServicePolicyPage.vue?vue&type=style&index=0&id=78534c8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports